import he from 'he';
import linkifyHtml from 'linkifyjs/html';

export function sanitizeText(str: string) {
  if (!str) return str;
  return he.decode(str)?.replace(/</g, '&lt;')?.replace(/>/g, '&gt;');
}

export function wrapUrlsWithAnchorTags(str: string, className = 'auto-generated', openExternal = false) {
  return linkifyHtml(str, {
    className,
    defaultProtocol: "https",
    target: {
      url: openExternal ? '_blank' : '_self',
    },
  });
}
